import { AfterViewInit, Component, OnInit } from '@angular/core';
import { DocumentType } from '@app/core/enums/document/document-type.enum';
import { EntityTypeEnum } from '@app/core/enums/entity-type.enum';
import { Document } from '@app/core/model/entities/document/document';
import {
  ListFieldBuilderComponent
} from '@app/shared/components/fields/list-field-builder/list-field-builder.component';

@Component({
    selector: 'document-type-field-builder',
    templateUrl: './document-type-field-builder.component.html',
    styleUrls: ['./document-type-field-builder.component.scss'],
    standalone: false
})
export class DocumentTypeFieldBuilderComponent extends ListFieldBuilderComponent implements OnInit, AfterViewInit {
  protected document = this.entity as Document;
  public options: { value: DocumentType, displayName: string }[] = [];

  constructor() {
    super();
    if ([EntityTypeEnum.ASSET, EntityTypeEnum.WORK, EntityTypeEnum.EQUIPMENT].includes(this.document.entityType)) {
      // Document type may be changed for DOCUMENT or PICTURE for these entities
      // For other entity types, field won't be editable due to conditionsToEdit
      this.options = [DocumentType.DOCUMENT, DocumentType.PICTURE].map(type => {
        return {
          value: type,
          displayName: this.translate.instant(`VALUE.DOCUMENT_TYPE_${this.document.entityType}_${type}`)
        };
      });
    }
  }
}
